// extracted by mini-css-extract-plugin
module.exports = {"book_box":"book_box-16QHm3jB"};